import { types } from './types';
import firebase from '../firebase/firebase';

const db = firebase.database();

export const updateWindowDimensions = ({width, height}) => {
    
    return {
        type: types.UPDATE_WINDOW_DIMENSIONS,
        payload: {
            width,
            height
        }
    }
}




// WEBPACK FOOTER //
// ./src/js/actions/screen-actions.js